import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, unref as _unref, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form-header-flex" };
const _hoisted_2 = { class: "header-left" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "subtitle" };
const _hoisted_5 = { class: "header-right" };
const _hoisted_6 = { class: "form-content" };
import { computed, provide, reactive, ref, useSlots, watch } from "vue";
import { Form } from "@primevue/forms";
import { z } from "zod";
import { zodResolver } from "@primevue/forms/resolvers/zod";
import UDivider from "@/components/uikit/uComponents/UDivider.vue";
import UTextHeader from "@/components/uikit/uComponents/UTextHeader.vue";
import { createValidationSchema } from "@/help/uInput";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UForm',
    props: {
        padding: { default: "20px" },
        gap: { default: "20px" },
        initialValues: { default: () => ({}) },
        footerFlex: { default: "flex-end" },
        submitButtonText: { default: "Submit" },
        loading: { type: Boolean, default: false }
    },
    emits: ["submitForm"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const inputs = ref([]);
        const validationSchema = computed(() => {
            if (inputs.value.length > 0) {
                return createValidationSchema(inputs.value);
            }
            return z.object({});
        });
        const resolver = computed(() => zodResolver(validationSchema.value));
        // Предоставляем функцию для регистрации инпутов
        const registerInput = (config) => {
            if (!inputs.value.find(input => input.name === config.name)) {
                inputs.value.push(config);
            }
        };
        provide("registerInput", registerInput);
        const FormProvider = {
            props: ["form"],
            setup(props, { slots }) {
                // Создаем reactive объект для полей формы
                const formFields = reactive({});
                // Следим за изменениями formData
                watch(() => props.form, (newForm) => {
                    // Копируем только поля формы (исключаем методы)
                    for (const key in newForm) {
                        if (key !== "register" && key !== "reset" && key !== "valid" &&
                            typeof newForm[key] === "object") {
                            formFields[key] = { ...newForm[key] };
                        }
                    }
                }, { deep: true, immediate: true });
                const getFieldError = (fieldName) => {
                    return formFields[fieldName]?.error?.message;
                };
                provide("getFieldError", getFieldError);
                return () => slots.default?.();
            }
        };
        const isFormDirty = ref(false);
        const onFormSubmit = (data) => {
            isFormDirty.value = true;
            if (!data.valid) {
                for (const input of inputs.value) {
                    if (input.name && Object.keys(data.errors).includes(input.name)) {
                        const firstErrorInput = document.querySelector(`[name=${input.name}]`);
                        if (firstErrorInput) {
                            firstErrorInput.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }
                        break;
                    }
                }
            }
            if (data.values) {
                emits("submitForm", data.values);
            }
        };
        const slots = useSlots();
        const hasHeader = computed(() => !!slots["header-left"] ||
            !!slots["header-right"] ||
            !!slots["header"] ||
            !!slots["title"] ||
            !!slots["subtitle"]);
        const footerStyle = computed(() => ({
            "justify-content": props.footerFlex
        }));
        const formStyle = computed(() => ({
            "--padding": props.padding,
            "--gap": props.gap
        }));
        return (_ctx, _cache) => {
            const _component_UButton = _resolveComponent("UButton");
            return (_openBlock(), _createElementBlock("div", {
                class: "card form-container",
                style: _normalizeStyle(formStyle.value)
            }, [
                _createVNode(_unref(Form), {
                    ref: "innerForm",
                    "initial-values": __props.initialValues,
                    resolver: resolver.value,
                    onSubmit: onFormSubmit
                }, {
                    default: _withCtx(($form) => [
                        _createVNode(FormProvider, { form: $form }, {
                            default: _withCtx(() => [
                                (hasHeader.value)
                                    ? (_openBlock(), _createBlock(UTextHeader, {
                                        key: 0,
                                        class: "form-header"
                                    }, {
                                        default: _withCtx(() => [
                                            _renderSlot(_ctx.$slots, "header", {}, () => [
                                                _createElementVNode("div", _hoisted_1, [
                                                    _createElementVNode("div", _hoisted_2, [
                                                        _renderSlot(_ctx.$slots, "header-left", {}, () => [
                                                            _createElementVNode("div", null, [
                                                                _createElementVNode("div", _hoisted_3, [
                                                                    _renderSlot(_ctx.$slots, "title")
                                                                ]),
                                                                _createElementVNode("div", _hoisted_4, [
                                                                    _renderSlot(_ctx.$slots, "subtitle")
                                                                ])
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_5, [
                                                        _renderSlot(_ctx.$slots, "header-right")
                                                    ])
                                                ])
                                            ]),
                                            _createVNode(UDivider, { class: "mt-3 mb-0" })
                                        ]),
                                        _: 3
                                    }))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_6, [
                                    _renderSlot(_ctx.$slots, "default", { $form: $form })
                                ]),
                                _renderSlot(_ctx.$slots, "footer", {}, () => [
                                    _createElementVNode("div", {
                                        class: "form-footer",
                                        style: _normalizeStyle(footerStyle.value)
                                    }, [
                                        _renderSlot(_ctx.$slots, "footerControls", { $form: $form }),
                                        _renderSlot(_ctx.$slots, "submit", {}, () => [
                                            _createVNode(_component_UButton, {
                                                width: "fit-content",
                                                type: "submit",
                                                loading: __props.loading
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(__props.submitButtonText), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["loading"])
                                        ])
                                    ], 4)
                                ])
                            ]),
                            _: 2
                        }, 1032, ["form"])
                    ]),
                    _: 3
                }, 8, ["initial-values", "resolver"])
            ], 4));
        };
    }
});
